import React, { useState, useEffect, useContext } from "react";
import BASE_URL from "../../../config/api";
import axios from "axios";
import "./HomePage.css";
import { CircularProgress } from "@mui/material";
import { AppContext } from "../../../context/AppContext";
import { useParams } from "react-router";

import CourseCard from "../../../components/UserDashboard/CourseCard/CourseCard";

export default function HomePage() {
  const { token } = useContext(AppContext);
  const [loading, setLoading] = useState(true);
  const [courses, setCourses] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/courses`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setCourses(response.data);
        setLoading(false);
      } catch (error) {
        // console.log(error.response.data);
        setLoading(false);
      }
    };

    if (token) fetchCourses();
  }, [token]);

  return (
    <>
      <div className="homepage-wrapper">
        {loading ? (
          <CircularProgress />
        ) : courses && courses.length > 0 ? (
          <>
            <p className="title">Available courses</p>
            <div className="user-courses">
              {courses.map((course) => (
                <CourseCard key={course._id} course={course} userId={id} />
              ))}
            </div>
          </>
        ) : (
          <p>No courses available.</p>
        )}
      </div>
    </>
  );
}
